import {
  Search,
  Tags,
  CalendarCheck,
  Scissors,
  Hourglass,
  Heart,
  Clock,
  MapPin,
  Wallet,
  ShieldCheck,
  Star,
  Users,
} from "lucide-react";

export const ICONS = {
  search: Search,
  tags: Tags,
  calendar: CalendarCheck,
  scissors: Scissors,
  hourglass: Hourglass,
  heart: Heart,
  clock: Clock,
  map: MapPin,
  wallet: Wallet,
  shield: ShieldCheck,
  star: Star,
  users: Users,
};

export const ICON_KEYS = Object.keys(ICONS);
